// json-data.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JsonDataService {
  private jsonUrlBase = environment.assetsPrefixUrl + '/configs/'; // Path to your JSON file

  constructor(private http: HttpClient) { }

  getJsonData(jsonFile: string, overrideFolder?: string): Observable<any> {
    const jsonUrlBase = overrideFolder ? environment.assetsPrefixUrl + '/'+overrideFolder + '/' :this.jsonUrlBase;
    return this.http.get<any>(jsonUrlBase+jsonFile);
  }
}
